import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';
import type { GalleryItemForm } from '../models';
import type { FormArray } from '@angular/forms';

@Pipe({
  name: 'findItemGroupById',
})
export class FindItemGroupById implements PipeTransform {
  transform(value: FormArray<GalleryItemForm>, id: string): GalleryItemForm {
    return value.at(value.controls.findIndex(group => group.controls.id.value === id));
  }
}
